var escape = require("../../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".point_dialog[data-v-af389ee4]{position:fixed;background-color:transparent;background-image:url(" + escape(require("./images/矩形备份14@1x.png")) + ");background-size:100% 100%}.point_dialog .point_dialog_close[data-v-af389ee4]{position:absolute;top:10px;right:10px;width:20px;height:20px;background-image:url(" + escape(require("./images/bg_pop_close@1x.png")) + ");background-size:100% 100%;cursor:pointer}", ""]);

// exports
